module.exports = __webpack_public_path__ + "img/p301.8d0ccb2b.jpg";